type Props = {
  topic: string;
};

export function HiddenSeoContext({ topic }: Props) {
  void topic;
  return null;
}